import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    template: `<router-outlet></router-outlet>`,
    styleUrl: './app.scss'
})
export class App {
    protected readonly title = signal('SeagrassRestorer');

    constructor(library: FaIconLibrary, faConfig: FaConfig) {
        library.addIconPacks(fas, fab);        // register packs
        faConfig.fixedWidth = true;
        faConfig.defaultPrefix = 'fas';        // optional: lets <fa-icon icon="map"> work
    }

}
